import styled, { css } from 'styled-components';
/**
 * Navigation action container
 */
export const navigationActionContainerStyles = () => css `
	display: flex;
	align-items: center;
`;
export const NavigationActionContainer = styled.li `
	${navigationActionContainerStyles}
`;
